import IconLabel from './IconLabel.vue';

export default IconLabel;
